export const GET_INVENTORY_ITEM_WITH_QTY_ON_HAND = `query GetInventoryItemIdWithQtyOnHand($input: InventoryItemWithQuantityInput!) {
    getInventoryItemIdWithQtyOnHand(input: $input) {
        inventoryItemId
    }
}`;

export const GET_PARTS_DESCRIPTION = `
    query GetPartsDescription($partNumber: String!) {
        getPartsDescription(input: { partNumber: $partNumber }) {
            description
        }
    }
`;
export const GET_LUMBER_LOCATION_BY_ITEM = `
    query GetLumberLocationByItem($itemNumber: String!) {
        getLumberLocationByItem(input: { itemNumber: $itemNumber }) {
            item
            location
        }
    }
`;
export const GET_DIE_AND_DESCRIPTION = `
    query GetDieAndDescription($organizationId: Int!, $item: String!) {
        getDieAndDescription(input: { organizationId: $organizationId, item: $item }) {
            item
            die
            description
        }
    }
`;
export const GET_LUMBER_ITEM_INFO_BY_SCHEDULE = `
    query GetLumberItemInfoBySchedule($scheduleNumber: String!) {
        getLumberItemInfoBySchedule(input: { scheduleNumber: $scheduleNumber }) {
            aQty
            aItem
            location
            finalFamily
            panSize
            scheduleNumber
        }
    }
`;
export const GET_PUT_DOWN_MILL_LOOKUP_BY_ITEM = `
    query GetPutDownMillLookupByItem($item: String!) {
        getPutDownMillLookupByItem(input: { item: $item }) {
            lotNumber
            lotDate
            qOH
        }
    }
`;
